var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 9,
    viewBox: "0 0 21 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.926758 8.08826V0.225952H5.98145V1.57361H2.40918V3.44958H5.66699V4.79724H2.40918V6.7406H6.04883V8.08826H0.926758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14941 8.08827V0.225967C8.08862 0.299738 11.0455 0.0199922 11.8555 0.483718C13.4027 1.10839 13.422 3.68926 11.8447 4.24647V4.44862C13.376 4.43152 12.615 7.22247 12.7881 8.08827H11.3057C11.3209 5.26422 11.8026 4.90855 8.63184 5.12343V8.08827H7.14941ZM8.63184 3.77479C9.55899 3.70964 11.6996 4.17569 11.5302 2.61854C11.6026 1.16208 9.51185 1.65311 8.63184 1.57362V3.77479Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 8.08824V0.225938C15.1988 0.308215 17.9776 -0.00397432 18.792 0.52379C21.8406 2.86733 18.9376 5.98516 15.7305 5.21324V8.08824H14.248ZM15.7305 3.86461C19.5199 4.47497 19.5117 0.962079 15.7305 1.57359V3.86461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIcon);
export default __webpack_public_path__ + "static/media/erp-icon.c3602da2a3d08b991f90c0800249229a.svg";
export { ForwardRef as ReactComponent };